import React, { useEffect, useState } from  "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import RouteManager, { PAGE_ROUTES }  from "../../managers/RouteManager";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import TenantManager from "../../managers/TenantManager";
import { selectMyAppliedCompOffRequests,fetchMyAppliedCompoffs, selectConfigurationSettings, fetchCompOffSettings } from "../../Redux/Slices/CompOffSlice";
import Utility, { deepClone, removeDelayedLoader, showDelayedLoader } from "../../utility/Utility";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { AppliedCompOffDetailRow, parseColumnConfig } from "../configs/config";
import { removeLoader,showLoader, TOAST_TYPE,showToast,showAlert}  from "deskera-ui-library";
import ApplyCompOff from "./ApplyCompOff";
import { saveAs } from 'file-saver';
import { getFileName } from "../configs/config";
import AttachmentService from "../../services/AttachmentService";
import { CompoffService } from "../../services/CompOffService";
import { INPUT_TYPE } from "../../constants/Constant";
import zeroState from "../../assets/images/zero-state-default.svg";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import { STATUS_COMP_OFF } from "./CompOffConstants";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

const AppliedCompOff = (props) => {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };

    const history = useHistory();
    const { t } = useTranslation();

    /**Hooks */
    const [appliedCompOffsData, setAppliedCompOffsData] = useState(initialState);
    const [filterArray, setFilterArray] = useState([]);
    const [tenantDetails, setTenantDetails] = useState(TenantManager.getTenantDetails);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    const [isLoading, setLoadingFlag] = useState(true);
    const [appliedCompOffPopupData, setAppliedCompOffsPopUpData] = useState({
        isEdit: false,
        data: {},
        enable: false
    });
    const [reload, setReload] = useState(false);

    /**Selectors */
    const compOffRequestsGridData = useSelector(selectMyAppliedCompOffRequests);
    const configurationSetting = useSelector(selectConfigurationSettings);

    
    /**Dispatch */
    const dispatch = useDispatch();

    useEffect(() => {
        loadConfigurationSettings()
    }, [])

    useEffect(() => {
        setLoadingFlag(true);
        RouteManager.setPresenter({ props: { ...props, history: history } })
        getAppliedCompoffs({page:1, limit:20, condition:[]});
        window.downloadCompOffFile = (url) => {
            const path = Utility.decodeJSON(url)
            downloadDocument(path);
        }
        return () => {
            window.downloadCompOffFile = null;
        }
    }, [configurationSetting]);

    useEffect(() => {
        if (!Utility.isEmptyObject(compOffRequestsGridData)) {
            setLoadingFlag(true);
            // const filterResponse = appliedCompOffsData.filterResponse;
            const compOffAppliedRequests = compOffRequestsGridData?.data || [];
            const { tenant } = TenantManager.getPeopleTenantData();
            
            const rowData = AppliedCompOffDetailRow(compOffAppliedRequests);
            let columnConfig = parseColumnConfig(TableManger.getTableColumns(TABLES.PEOPLE_APPLY_COMP_OFF_REQUEST), TABLES.PEOPLE_APPLY_COMP_OFF_REQUEST);

            const passingData = {
                columnData: deepClone(columnConfig),
                rowData,
                filter: [],
                originalData: compOffAppliedRequests
            };
            removeLoader();
            setAppliedCompOffsData(passingData);
            setTotalPageCount(compOffRequestsGridData.totalPages);
            setCurrentPage(compOffRequestsGridData?.page);
            setTotalCount(compOffRequestsGridData.numberOfRecords);
            setLoadingFlag(false);
        } else {
            const rowData = [];
            let columns = parseColumnConfig(TableManger.getTableColumns(TABLES.PEOPLE_APPLY_COMP_OFF_REQUEST), TABLES.PEOPLE_APPLY_COMP_OFF_REQUEST);
            const passingData = {
                columnData: deepClone(columns),
                rowData,
                filter: [],
                originalData: []
            };
            setAppliedCompOffsData(passingData);
            setLoadingFlag(false);
        }
    }, [compOffRequestsGridData, reload]);

    const loadConfigurationSettings = async () => {
        try {
            await dispatch(fetchCompOffSettings());
        } catch (err) {

        }
    }

    const getAppliedCompoffs =async(configObj) => {
        const timeOut = showDelayedLoader()
        try {
            if(configObj) {
                const config = {
                    ...CompoffService.appliedCompOffApiConfig,
                    ...configObj
                }
                CompoffService.appliedCompOffApiConfig = config;
            }
            
            setLoadingFlag(true);
            await dispatch(fetchMyAppliedCompoffs())
        } catch (err) {

        }
        removeDelayedLoader(timeOut)
    }
    const onDeleteCOmpOff = (data) => {
        const isAdmin = TenantService.get(TENANT.IS_ADMIN);
        if(!isAdmin && !configurationSetting.isCompOffEnabledForEmployee) {
            showAlert("Not allow to delete Compensatory Off","Please contact to your administrator to allow you to delete Compensatory Off.");
            return;
        }
        const dataToDelete = data.rowData ? [data.rowData.data] :data.map(d=>d.data);
        let isAllowToDelete = isAdmin;
        if(!isAllowToDelete) {
            const nonPendingCompOff = dataToDelete.filter(c=>c.status != STATUS_COMP_OFF.PENDING);
            if(nonPendingCompOff && nonPendingCompOff.length > 0 ) {
                showAlert("Not allow to delete","You are not allow to delete selected Compensatory Off");
                return;
            }
        }       
        
        CompoffService.deleteAppliedCompOff(dataToDelete).then(res=>{
            showToast(res,TOAST_TYPE.SUCCESS);
            getAppliedCompoffs(
                {
                    ...CompoffService.appliedCompOffApiConfig,
                    page:1
                }
            )
        },error=>{
            if(error && error.message) {
                showToast(error.message,TOAST_TYPE.FAILURE);
            } else {
                showToast('Something went wrong while deleting',TOAST_TYPE.FAILURE);
            }
        })
    }

    const onFilter = (data,query) => {
        let filterCondition = []
            let columnConfig = parseColumnConfig(TableManger.getTableColumns(TABLES.PEOPLE_APPLY_COMP_OFF_REQUEST), TABLES.PEOPLE_APPLY_COMP_OFF_REQUEST);
            query?.forEach(q=>{
                const config = columnConfig.find(col=>col.id===q.key);
                if(config) {
                    filterCondition.push({
                        colId: config.columnCode,
                        opr : q.condition,
                        key: config.columnCode,
                        value: ((q.value && config.type === INPUT_TYPE.SELECT) ? q.value[0]:q.value),
                        type: config.columnCode
                    })
                }
            })
            getAppliedCompoffs({
                    condition: filterCondition,
                    page:1
                })
            
    }

    const onCreateNew = () => {
        const isAdmin = TenantService.get(TENANT.IS_ADMIN)
        if(!isAdmin && !configurationSetting.isCompOffEnabledForEmployee) {
            showAlert("Not allow to Add Compensatory Off","Please contact to your administrator to allow you to add Compensatory Off.");
            return;
        }
        setAppliedCompOffsPopUpData({
            enable: true,
            data: {},
            isEdit: false
        })

    }
    const onRowEdit = (data) => {
        const isAdmin = TenantService.get(TENANT.IS_ADMIN);
        if(!isAdmin && !configurationSetting.isCompOffEnabledForEmployee) {
            showAlert("Not allow to Edit Compensatory Off","Please contact to your administrator to allow you to edit Compensatory Off.");
            return;
        }
        if(data?.rowData?.data?.status !== STATUS_COMP_OFF.PENDING) {
            const status = (data.rowData.data.status === STATUS_COMP_OFF.APPROVED) ? "Approved" : "Rejected" 
            showAlert("Compensatory Off was "+status+".", " Compensatory Off is not allow to edit.");
            return;
        }
        setAppliedCompOffsPopUpData({
            enable: true,
            data: data.rowData.data,
            isEdit: true
        })
    }

    const onPopupClose = (isReload) => {
        setAppliedCompOffsPopUpData({
            enable: false
        })
        if (isReload) {
            const isEdit = appliedCompOffPopupData?.isEdit
            let config = {
                ...CompoffService.appliedCompOffApiConfig
            }
            if(!isEdit) {
                config = {
                    ...config,
                    page:1
                }
            }
            getAppliedCompoffs(config);
        }
    }

    const downloadDocument = (path) => {
        showLoader("Downloading document... Please wait");
        AttachmentService.getPresignedURL(path).then(
            (response) => {
                AttachmentService.downloadFile(response).then(
                    (response) => {
                        removeLoader();
                        saveAs(response, getFileName(path));
                    },
                    (error) => {
                        removeLoader();
                    }
                );
            },
            (error) => {
                removeLoader();
                showToast("Something went wrong", TOAST_TYPE.FAILURE);
            }
        );
    }
    const onContextCancel =()=>{
        getAppliedCompoffs()
    }


    const nevigateToSetting = () => {
        RouteManager.navigateToPage(PAGE_ROUTES.COMP_OFF.CONFIGURE_COMP_OFF)
    }

    return(
        <>
        {!configurationSetting.isCompOffEnabled ? 
                (
                    <div className="d-flex justify-content-center parent-width parent-height">
                        <div className="row" style={{ width: "60%" }}>
                            <div className="bg-white p-h-xl pt-r pb-l border-m border-radius-m border-box dashboard-card column align-items-center parent-width">
                                <div>
                                    <img className="ic-xxl pt-xxl" src={zeroState}>
                                    </img>
                                </div>
                                {TenantService.get(TENANT.IS_ADMIN) ?

                                    (
                                        <>
                                            <div className="fw-b fs-xl pt-xl">
                                                It seems comp-off isn't enabled yet, Please enable to Manage comp-off!
                                            </div>
                                            <div className="d-flex fs-m fw-r pt-l">
                                                <div className="text-app cursor-hand" onClick={nevigateToSetting}>
                                                    <u>Click here</u>&nbsp;
                                            </div>
                                                <div>
                                                    to enable
                                            </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="fw-b fs-xl pt-xl">
                                            It seems comp-off isn't enabled yet, Please contact your manager!
                                        </div>
                                    )

                                }



                            </div>
                        </div>
                    </div>


                ) : (
        <div className="column parent-width flex-1">
                <div className="column parent-width mb-s position-relative flex-1">
                    <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_APPLY_COMP_OFF_REQUEST}
                        displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_APPLY_COMP_OFF_REQUEST]}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={true}
                        allowColumnAdd={false}
                        onRowDelete={onDeleteCOmpOff}
                        onRowEdit={(data) => {
                            onRowEdit(data);
                        }}
                        onCancelContext={() => {
                            onContextCancel();
                        }}
                        addButtonConfig={[
                            {
                                title: "+ Apply Comp Off",
                                className: "bg-app text-white ml-s",
                                onClick: () => onCreateNew(),
                            }
                        ]}
                        allowDataExport={false}
                        gridData={appliedCompOffsData}
                        onFilter={onFilter}
                        filter={filterArray}
                        onPaginationClick={(requestedPageNumber) => {
                              const config = {
                                page: requestedPageNumber
                              };
                              getAppliedCompoffs(config);
                        }}
                        currentPage={currentPage}
                        totalPageCount={totalPageCount}
                        isActionEnabled={true}
                        contextMenu={true}
                        isMenuVisible={true}
                        allowRowEdit={true}//PermissionUtils.hasAccess(MODULE.MY_COMP_OFF,ACTION.EDIT)
                        showContextEdit={false}
                        onColumnShift={(data)=> setReload(!reload)}
                        // module={MODULE.MY_COMP_OFF} // will use
                    // onSort={(data)=>{onSort(data)}}
                    // onRowUpdate={(data) => {onColumnRowUpdate(data)}}
                    />
                </div>
            </div>
            )}
            {appliedCompOffPopupData.enable && <ApplyCompOff isEdit={appliedCompOffPopupData.isEdit} data={appliedCompOffPopupData.data} onClose={(isReload) => onPopupClose(isReload)}  />}
        
                </>

    )
}

export default AppliedCompOff;